/**
 * SQL 품질 검사 결과 상세 — 원문을 강조 조각으로 나눈다(docs/features/27-sql-quality.md §5 「선택된 쿼리 전체, 체크된 부분 표시」).
 * 범위는 서버가 준 **원문 글자 위치**다. 겹치면 합치고, 고른 발견 사항의 범위는 따로 표시한다(on). 문장 밖을 가리키는 범위는 버린다.
 *
 * @param sql    원문
 * @param marks  [{ ranges: [[s, e]], key }]
 * @param activeKey 고른 발견 사항의 key — 그 범위는 on
 * @returns [{ text, mark: boolean, on: boolean, keys: [] }]
 */
export function markSegments(sql, marks, activeKey = null) {
  const s = String(sql || '');
  const cuts = new Set([0, s.length]);
  const spans = [];
  for (const m of marks || []) {
    for (const r of m.ranges || []) {
      const a = Math.max(0, Math.min(s.length, Number(r[0])));
      const b = Math.max(0, Math.min(s.length, Number(r[1])));
      if (!(b > a)) continue;
      spans.push({ a, b, key: m.key });
      cuts.add(a); cuts.add(b);
    }
  }
  const pts = [...cuts].sort((x, y) => x - y);
  const out = [];
  for (let i = 0; i + 1 < pts.length; i += 1) {
    const a = pts[i]; const b = pts[i + 1];
    const keys = spans.filter(sp => sp.a <= a && sp.b >= b).map(sp => sp.key);
    const seg = { text: s.slice(a, b), mark: keys.length > 0, on: activeKey != null && keys.includes(activeKey), keys: [...new Set(keys)] };
    const last = out[out.length - 1];
    if (last && last.mark === seg.mark && last.on === seg.on && last.keys.join() === seg.keys.join()) last.text += seg.text;
    else out.push(seg);
  }
  return out;
}

/** 검사기 묶음(메모의 검사 유형) — 화면의 거르기 칩 순서 */
export const CHECK_GROUPS = [
  { id: 'standard', checks: ['ansiJoin', 'tableAlias', 'keywordCase', 'selectStar'] },
  { id: 'logic', checks: ['distinct', 'scalarRownum', 'groupByMinMax'] },
  { id: 'cleansing', checks: ['cleanseFunc', 'nullPatch', 'typeConvert'] },
  { id: 'model', checks: ['joinNoKey', 'joinTypeMismatch'] },
  { id: 'perf', checks: ['perf'] },
];
export const VERDICTS = ['logicError', 'dataCleansing', 'modelImprove', 'tuning', 'ruleViolation', 'ok', 'unknown'];
export const REVIEW_STATUS = ['todo', 'ok', 'fix', 'ignore'];

/**
 * 에이전트에게 화면 내용을 보낼 때의 값 가리기 — 문자열과 세 자리 이상 숫자를 :v 로(서버 `sqlAuthor/similar.maskLiterals` 와 같은 뜻).
 * DB 에서 온 문장은 이미 가려져 있고, CSV·사람이 쓴 글도 대화로 나갈 때는 가린다. 주석·따옴표 이름은 그대로.
 */
export function maskForAgent(sql) {
  return String(sql || '').replace(/(--[^\n]*|\/\*[\s\S]*?\*\/|"(?:[^"]|"")*")|'(?:[^']|'')*'|\b\d{3,}(?:\.\d+)?\b/g, (m, keep) => (keep || ':v'));
}
